// extracted by mini-css-extract-plugin
export default {"container":"ElementWithIcon_container__lDXEb","logoContainer":"ElementWithIcon_logoContainer__GUnQk"};